export const UPDATE_OFFERS = "Lädt alle Angebote";
export const UPDATE_CURRENT_OFFER = "Aktualisiert das aktuelle Angebot";
export const MARK_OFFER_ADMISSION_STATUS =
  "Markiere die Zulassung eines Angebot";
export const MARK_OFFER_AWARD_STATUS = "Markiere den Zuschlag eines Angebot";
export const name = "offers";
